// extracted by mini-css-extract-plugin
export default {"wrapper":"VirtualTableWithPaidOrdersScreen_wrapper__gkGU-","fetchMoreWrapper":"VirtualTableWithPaidOrdersScreen_fetchMoreWrapper__8Om7O"};